module.exports = __webpack_public_path__ + "static/media/11.925225b0.png";